export const ExtensionSliceMap = {
  // (MedicationKnowledge) Formulary Drugs Extension Slices
  MedicationKnowledge: {
    priorAuthorization: {
      url: 'http://hl7.org/fhir/us/davinci-drug-formulary/StructureDefinition/usdf-PriorAuthorization-extension',
      valueKey: 'valueBoolean'
    },
    stepTherapyLimit: {
      url: 'http://hl7.org/fhir/us/davinci-drug-formulary/StructureDefinition/usdf-StepTherapyLimit-extension',
      valueKey: 'valueBoolean'
    },
    quantityLimit: {
      url: 'http://hl7.org/fhir/us/davinci-drug-formulary/StructureDefinition/usdf-QuantityLimit-extension',
      valueKey: 'valueBoolean'
    },
    mailOrder: {
      url: 'http://hl7.org/fhir/us/davinci-drug-formulary/StructureDefinition/usdf-MailOrder-extension',
      valueKey: 'valueBoolean'
    },
    planId: {
      url: 'http://hl7.org/fhir/us/davinci-drug-formulary/StructureDefinition/usdf-PlanID-extension',
      valueKey: 'valueString'
    },
    drugTierId: {
      url: 'http://hl7.org/fhir/us/davinci-drug-formulary/StructureDefinition/usdf-DrugTierID-extension',
      valueKey: 'valueCodeableConcept'
    },
  },
// (List) Formulary Coverage Plan Extension Slices
  FormularyCoveragePlan: {
    network: {
      url: 'http://hl7.org/fhir/us/davinci-drug-formulary/StructureDefinition/usdf-Network-extension',
      valueKey: 'valueString',
    },
    summaryURL: {
      url: 'http://hl7.org/fhir/us/davinci-drug-formulary/StructureDefinition/usdf-SummaryURL-extension',
      valueKey: 'valueUrl',
    },
    formularyURL: {
      url: 'http://hl7.org/fhir/us/davinci-drug-formulary/StructureDefinition/usdf-FormularyURL-extension',
      valueKey: 'valueUrl',
    },
    emailPlanContact: {
      url: 'http://hl7.org/fhir/us/davinci-drug-formulary/StructureDefinition/usdf-EmailPlanContact-extension',
      valueKey: 'valueUrl',
    },
    marketingURL: {
      url: 'http://hl7.org/fhir/us/davinci-drug-formulary/StructureDefinition/usdf-MarketingURL-extension',
      valueKey: 'valueUrl',
    },
    planIdType: {
      url: 'http://hl7.org/fhir/us/davinci-drug-formulary/StructureDefinition/usdf-PlanIDType-extension',
      valueKey: 'valueString',
    },
    // slices nested in drugTierDefinition: 
    mailOrder: {
      url: 'mailOrder',
      valueKey: 'valueBoolean',
    },
    drugTierID: {
      url: 'drugTierID',
      valueKey: 'valueCodeableConcept',
    },
  },
  Address: {
    latitude: {
      url: 'latitude',
      valueKey: 'valueDecimal'
    },
    longitude: {
      url: 'longitude',
      valueKey: 'valueDecimal'
    }
  },
  PractitionerRole:{
    qualificationCode: {
      url: 'code',
      valueKey: 'valueCodeableConcept'
    }
  }
   // other Extension Slices can be added here
  }